import _from from './from';
import type { Types } from './types';

export class PlanDigitalMap {
  static from = _from;
}

export { Types as PlanDigitalTypes };